import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DisclosureFile {
  name: string;
  url: string;
}

interface DisclosureItem {
  title: string;
  files: DisclosureFile[];
  open: boolean;
}

@Component({
  selector: 'app-shop-grid-page',
  templateUrl: './shop-grid-page.component.html',
  styleUrls: ['./shop-grid-page.component.scss']
})
export class ShopGridPageComponent implements OnInit {
  isToggled = false;

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  get totalFiles(): number {
    return this.menuItems.reduce((total, item) => total + item.files.length, 0);
  }

  isExternalLink(url: string): boolean {
    return /^https?:\/\//i.test(url);
  }

  toggleMenu(index: number): void {
    this.menuItems = this.menuItems.map((item, i) => ({
      ...item,
      open: i === index ? !item.open : false
    }));
  }

  trackByTitle(index: number, item: DisclosureItem): string {
    return item.title;
  }

  trackByFileName(index: number, file: DisclosureFile): string {
    return file.name;
  }

  menuItems: DisclosureItem[] = [
    {
      title: 'Prospectus',
      files: [
        { name: 'College Prospectus', url: 'assets/pdfs/FMCET_Prospectus.pdf' },
        { name: 'NAAC Accreditation', url: 'assets/pdfs/NAAC Certificate.pdf' },
        { name: 'UGC 2F Certificate', url: 'assets/pdfs/UGC 2f Certiicate.pdf' }
      ],
      open: false
    },
    {
      title: 'Student Grievance Redressal Committee',
      files: [
        { name: 'Student Grievance Redressal Committee', url: 'assets/pdfs/Student Grievance Redressal Committee.pdf' },
        { name: 'OMBUDPERSON', url: 'assets/pdfs/OMBUDPERSON.pdf' }
      ],
      open: false
    },
    {
      title: 'Admission Process & Guidelines',
      files: [
        { name: 'Admission Process & Guidelines', url: 'assets/pdfs/Admission Process & Guidelines.pdf' }
      ],
      open: false
    },
    {
      title: 'Fee Refund Policy',
      files: [
        { name: 'Fee Refund Policy', url: 'assets/pdfs/Fee Refund Policy.pdf' }
      ],
      open: false
    },
    {
      title: 'Internal Compliance Committee',
      files: [
        { name: 'Internal Compliance Committee', url: 'assets/pdfs/Internal Compliance Committee.pdf' }
      ],
      open: false
    },
    {
      title: 'Sexual Harassment Committee',
      files: [
        { name: 'Sexual Harassment Committee', url: 'assets/pdfs/Sexual Harassment Committee.pdf' }
      ],
      open: false
    },
    {
      title: 'Anti Ragging Cell',
      files: [
        { name: 'Anti Ragging Cell', url: 'assets/pdfs/Anti Ragging Cell.pdf' }
      ],
      open: false
    },
    {
      title: 'Statutory Declaration of RTI Act',
      files: [
        { name: 'Statutory Declaration of RTI Act', url: 'assets/pdfs/STATUTORY DECLARATION OF RTI ACT.pdf' }
      ],
      open: false
    },
    {
      title: 'Library',
      files: [
        { name: 'Library Book List', url: 'assets/pdfs/Library Book List.pdf' }
      ],
      open: false
    },
    {
      title: 'Research and Development Cell',
      files: [
        { name: 'Research and Development Cell', url: 'assets/pdfs/FMCET Research 2025.pdf' }
      ],
      open: false
    },
    {
      title: 'Faculty Detail with their Qualification',
      files: [
        { name: 'Faculty Detail with their Qualification', url: 'assets/pdfs/STAFF DETAILS.pdf' }
      ],
      open: false
    },
    {
      title: 'Annual Accounts of the College',
      files: [
        { name: 'Annual Accounts of the College', url: 'assets/pdfs/Financial Statements.pdf' }
      ],
      open: false
    },
    {
      title: 'IQAC',
      files: [
        { name: 'IQAC', url: 'assets/pdfs/IQAC Team.pdf' }
      ],
      open: false
    },
    {
      title: 'Sports Facilities',
      files: [
        { name: 'Sports Facilities', url: 'assets/pdfs/List of Sports Equipments.pdf' }
      ],
      open: false
    },
    {
      title: 'NSS Details',
      files: [
        { name: 'NSS Details', url: 'assets/pdfs/NSS Activity.pdf' }
      ],
      open: false
    },
    {
      title: 'Institute Development Plan',
      files: [
        { name: 'Institute Development Plan', url: 'assets/pdfs/Institute Development Plan.pdf' }
      ],
      open: false
    },
    {
      title: 'Health Facilities',
      files: [
        { name: 'Health Facilities', url: 'assets/pdfs/Health Facility.pdf' }
      ],
      open: false
    },
    {
      title: 'Details of Alumni Association',
      files: [
        { name: 'Details of Alumni Association', url: 'assets/pdfs/FMCET Alumini Association.pdf' }
      ],
      open: false
    },
    {
      title: 'Circulars and Notices',
      files: [
        { name: 'Circulars and Notices', url: 'assets/pdfs/Circular.pdf' }
      ],
      open: false
    },
    {
      title: 'Announcements',
      files: [
        { name: 'Announcements', url: 'assets/pdfs/Announcement.pdf' }
      ],
      open: false
    },
    {
      title: 'News Recent Events',
      files: [
        { name: 'News Recent Events', url: 'assets/pdfs/News Recent Events.pdf' }
      ],
      open: false
    },
    {
      title: 'Placement Cell',
      files: [
        { name: 'Placement Cell', url: 'assets/pdfs/Placement Activitites.pdf' }
      ],
      open: false
    },
    {
      title: 'Job Opportunities',
      files: [
        { name: 'Job Opportunities', url: 'assets/pdfs/Job Offering.pdf' }
      ],
      open: false
    },
    {
      title: 'Facilities available for Physically Challenged People',
      files: [
        { name: 'Facilities available for Physically Challenged People', url: 'assets/pdfs/Facilities available for Physically Challenged People.pdf' }
      ],
      open: false
    },
    {
      title: 'Picture Gallery',
      files: [
        { name: 'Picture Gallery', url: 'http://fmcet.ac.in/gallery' }
      ],
      open: false
    },
    {
      title: 'Contact Details',
      files: [
        { name: 'Contact Details', url: 'http://fmcet.ac.in/contact' }
      ],
      open: false
    },
    {
      title: 'Telephone Directory',
      files: [
        { name: 'Telephone Directory', url: 'http://fmcet.ac.in/contact' }
      ],
      open: false
    }
  ];
}